import React from 'react';
import { withRouter } from 'react-router';

declare global {
    interface Window {
        swUpdate:any;
    }
}

let swUpdate = window.swUpdate; // ok now

const LinkDiv = (props: { [x: string]: any; history: any; location: any; match: any; staticContext: any; to: any; onClick: any; }) => {
  const {
    history,
    location,
    match,
    staticContext,
    to,
    onClick,
    // ⬆ filtering out props that `button` doesn’t know what to do with.
    ...rest
  } = props;
  return (
    <div
      {...rest} // `children` is just another prop!
      onClick={event => {
        onClick && onClick(event);
        if (swUpdate) {
          event.preventDefault();
          window.location = to;
        }
        history.push(to);
      }}
    />
  )
};

export default withRouter(LinkDiv);